import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Filter } from "~/features/filter";
import { uploadsFilterFields } from "~/widgets/Filter/UploadsFilter/model/fields";

export const UploadsFilter = () => {
  const { t } = useTranslation();
  const fields = useMemo(() => uploadsFilterFields(t), [t]);

  return <Filter.Root fields={fields} alwaysShow columns={4} />;
};
